@if(registerForm){
    <h1>
        Register
    </h1>
    <form [formGroup]="registerForm">
        <input formControlName="userName" placeholder="User name" />
        <input type="email" formControlName="email" placeholder="Email" />
        <input type="password" formControlName="password" placeholder="Password" />
        <input type="password" formControlName="confirmPassword" placeholder="Confirm Password" />
        <button (click)="submit()">Submit</button>
    </form>

    <nav>
        Already have an Account? <a class="button" routerLink="/login">Sign In</a>
    </nav>
}